import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppSettingService } from "./app-setting.service";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
@Injectable()
export class TokenInterceptorService implements HttpInterceptor {

  loggedInUser: any;
  // appSettingService: any;
  route: any;
  constructor(private appSettingService:AppSettingService,private router:Router) {

  }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    
    // We retrieve the token, if any
    let newHeaders = req.headers;

    if (this.appSettingService.isAuthenticated)
     {
      const token = this.appSettingService.loggedInUser.access_token;
      if (token) {
        // If we have a token, we append it to our new headers
        
        newHeaders = newHeaders.append('Authorization', `bearer ` + token);
      }
    }
    // Finally we have to clone our request with our new headers
    // This is required because HttpRequests are immutable
    const authReq = req.clone({ headers: newHeaders });
    // Then we return an Observable that will run the request
    // or pass it to the next interceptor if any
    return next.handle(authReq).pipe( tap(() => {},
    (err: any) => {
    if (err instanceof HttpErrorResponse) {
      if (err.status !== 401) {
       return;
      }
      this.appSettingService.loggedInUser=null;
      this.router.navigate(['login']);
    }
  }));
  }


}